import numeral from "numeral";

const formatCurrency = (number, smaller) =>
  `${numeral(number).format("0,0")}${smaller ? "" : "円"}`;

const formatPoints = (points) => `${numeral(points).format("0,0")}`;

export { formatCurrency, formatPoints };
